<template>
  <v-card class="hide-overflow fill-height" color="white lighten-1" lighten>
    <v-progress-linear :active="renovando" class="ma-0" color="cyan accent-3" height="16" indeterminate>Preparando a renovação da sua assinatura - aguarde...</v-progress-linear>
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs6>
          <h2 style="color: #666">Ativar Assinatura</h2>
        </v-flex>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
        <br />

        <v-flex xs12>
          <v-form ref="formAssinar" v-model="assinarValid" lazy-validation class="mt-4" v-if="!renovando">
            <v-flex offset-md3 md6 offset-xs2 xs8 class="justify-center">
              <v-card>
                <v-card-title style="color: white" class="primary justify-center">Sua Assinatura</v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs9 class="ml-4 mb-2" style="min-height: 160px">
                        <h2 class="dadoCampo mt-2">Código</h2>
                        <h2 class="dadoValor">{{ assinatura.id }}</h2>

                        <h2 class="dadoCampo mt-2">Plano</h2>
                        <h2 class="dadoValor">{{ assinatura.plano }}</h2>

                        <h2 class="dadoCampo mt-2">Status</h2>
                        <h2 class="dadoValor">{{ assinatura.status }}</h2>

                        <h2 class="dadoCampo mt-2">Parcelamento</h2>
                        <h2 class="dadoValor">
                          {{ assinatura.parcelas ? assinatura.parcelas.length + " x " + formatCurrency(assinatura.parcelas[0].valor) + " = " + formatCurrency(valor) : "" }}
                        </h2>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>

            <CartaoCredito ref="cartaoCredito" :validacao.sync="validacao" :isUpdating.sync="isUpdating" v-if="!renovando && !payAsaas"></CartaoCredito>

            <v-flex xs12 v-if="payAsaas" text-center>
              <b><v-sheet class="ml-1 green--text" :value="true">Sua cobrança já foi gerada, verifique seu e-mail ou entre em contato com o jornal.</v-sheet></b>
            </v-flex>

            <v-flex xs12>
              <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.mensagemErro">{{ validacao.mensagemErro }}</v-sheet>
            </v-flex>
            <v-flex xs12 class="text-center" v-if="!payAsaas">
              <v-btn :disabled="isUpdating" :loading="loading" class="primary" large @click="passarCartao" v-if="!renovando">Ativar</v-btn>
            </v-flex>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="snackbar" color="info" :timeout="5000" centered>{{ mensagem }}</v-snackbar>
    <v-snackbar v-model="snackErro" color="error" :timeout="6000" centered>{{ mensagem }}</v-snackbar>
  </v-card>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../util";
import CartaoCredito from "../components/CartaoCredito.vue";
export default {
  components: { CartaoCredito },
  data() {
    return {
      idAssinatura: null,
      valor: 0,
      assinatura: {},
      cartao: {},

      validacao: {
        cartao_numero: false,
        cartao_nome: false,
        cartao_validade: false,
        cartao_cvv: false,

        mensagemErro: false
      },

      assinarValid: true,
      renovando: false,
      payAsaas: false,

      snackbar: false,
      snackErro: false,
      mensagem: "",

      isUpdating: false,
      loading: false
    };
  },
  methods: {
    async carregarAssinatura() {
      try {
        const response = await api.get("/ass/paywall/assinatura/" + this.idAssinatura);
        this.assinatura = response.data;
        if (this.assinatura.status != "PENDENTE") {
          //pois ao cair aqui, assinatura já foi renovada
          this.$router.push("/assinaturas");
        }
        this.assinatura.parcelas.forEach((element) => {
          this.valor += element.valor;
          if (element.payAsaas && element.formaPagamentoTipo != "CARTAO_CREDITO") {
            this.payAsaas = true;
          }
        });
        if (this.valor == 0) {
          this.$router.push("/assinaturas");
        }
      } catch (e) {
        this.$router.push("/assinaturas");
      }
    },

    async passarCartao() {
      this.isUpdating = true;
      this.loading = true;
      try {
        await util.limparObjeto(this.validacao, false);

        var novoCartao = this.$refs.cartaoCredito.retornaCartao();

        if (!novoCartao.cvv || !this.$refs.formAssinar.validate()) {
          this.validacao.mensagemErro = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        this.cartao = novoCartao;
        var body = {
          idAssinatura: this.idAssinatura,
          idRenovacao: this.assinatura.idRenovacao,
          idPlano: this.assinatura.idPlano,
          plano: this.assinatura.plano,
          dtInicio: util.dateToStringUS(this.assinatura.dtInicio),
          dtFim: util.dateToStringUS(this.assinatura.dtFim),
          cartaoIntegral: this.assinatura.cartaoIntegral && this.$store.state.usuario.cobranca.cartaoIntegral,
          valor: this.valor,
          parcelas: this.assinatura.parcelas,
          cartao: this.cartao
        };

        //* Envia o cartão
        var response = await api.post("/ass/paywall/cartao", body);

        if (response.data.erro) {
          //* Se houve erro ao tentar passar o cartão, bloqueia tudo, exceto a aba Cartão para que possa tentar passar novamente - pois a assinatura já está registrada como PROPOSTA
          util.validaErros(this.validacao, response.data.erros);
          this.idAssinatura = response.data.idAssinatura;
        } else {
          this.$router.push("/assinaturas");
        }
      } catch (e) {
        if (e.toString().includes("status code 400")) {
          this.validacao.mensagemErro = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data) {
          util.validaErros(this.validacao, e.response.data);
        } else {
          this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
        }
      } finally {
        this.isUpdating = false;
        this.loading = false;
      }
    },

    async renovar() {
      try {
        const response = await api.post("/ass/paywall/renovar-assinatura?idAssinatura=" + this.idAssinatura + "&idUsuario=1&online=1");
        return response.data;
      } catch (e) {
        return false;
      }
    },

    formatCurrency(val) {
      return util.formatCurrency(val);
    }
  },

  async created() {
    if (!this.$route.params.id) {
      this.$router.push("/assinaturas");
    } else {
      do {
        await util.delay(1000);
      } while (!this.$store.state.site.enderecoSite);

      if (!this.$store.state.site.paywall && !this.$store.state.site.assinante) {
        this.$router.push("/assine");
        return;
      }
      document.title = this.$store.state.site.nome;
      this.idAssinatura = this.$route.params.id;
      if (this.$route.query.expirada) {
        this.renovando = true;
        const renovada = await this.renovar();
        if (!renovada) {
          this.mensagem = "Ocorreu um erro ao renovar sua assinatura - entre em contato com o jornal.";
          this.snackErro = true;
          setTimeout(() => {
            this.$router.push("/assinaturas");
          }, 5000);
          return;
        } else {
          this.renovando = false;
          if (renovada.migrado) {
            this.mensagem = "SEU PLANO DE ASSINATURA FOI MIGRADO - Confira as informações acima e, em caso de dúvida, entre em contato com o jornal.";
            this.snackErro = true;
          }
        }
      }
      await this.carregarAssinatura();
    }
  }
};
</script>

<style>
.dadoCampo {
  font-size: 15px;
}

.dadoValor {
  font-weight: 300;
  font-size: 18px;
}
</style>
